import { Alert, Toggle } from '@pmi/dsm-react';
import React, { useEffect } from 'react';
import { CircleInfoIcon } from '@pmi/dsm-react/dist/components/icons/16';
import { AlertWarningSolidIcon } from '@pmi/dsm-react/dist/components/icons';
import { AccessRuleItems } from '../../../shared/models/AccessRule';
import styles from './access-rules.module.scss';

interface DomainAccessTabProps {
  rule: AccessRuleItems;
  pendingDomainAccessChange: boolean | null;
  onPendingDomainAccessChange: (change: boolean | null) => void;
  onPendingChangesUpdate?: (hasChanges: boolean) => void;
}

export default function DomainAccessTab({
  rule,
  pendingDomainAccessChange,
  onPendingDomainAccessChange,
  onPendingChangesUpdate = undefined,
}: DomainAccessTabProps) {
  const { isActive, domainName } = rule;
  const localIsActive =
    pendingDomainAccessChange !== null ? pendingDomainAccessChange : isActive;
  const hasChanged = localIsActive !== isActive;

  useEffect(() => {
    onPendingChangesUpdate?.(hasChanged);
  }, [hasChanged, onPendingChangesUpdate]);

  return (
    <div className="pb-3">
      <div className={styles.toggleContainer}>
        <Toggle
          checked={localIsActive}
          onChange={(
            event:
              | React.ChangeEvent<HTMLInputElement>
              | React.KeyboardEvent<HTMLInputElement>,
          ) =>
            onPendingDomainAccessChange(
              (event.target as HTMLInputElement).checked,
            )
          }
          textOn="Domain Access Enabled"
          textOff="Domain Access Disabled"
          name={`domain-access-${rule.id}`}
        />
      </div>
      <div className="mt-3">
        {localIsActive ? (
          <Alert
            icon={CircleInfoIcon}
            variant="info"
            alertText={`When enabled, all users with email addresses at @${domainName} will have access to the assigned products, except for emails in the exclusion list.`}
          />
        ) : (
          <Alert
            icon={AlertWarningSolidIcon}
            variant="warning"
            alertText={`When disabled, only existing users matching @${domainName} will have access to assigned products. Any new user matching @${domainName} will not be able to access the platform unless explicitly invited or domain is enabled.`}
          />
        )}
      </div>
    </div>
  );
}
